import { normalizePlainText } from './normalizePlainText';

function escapeHtmlPlain(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

const PRE_INLINE_STYLE =
  'margin:0;padding:0;white-space:pre;overflow-x:auto;font-family:ui-monospace,\'Courier New\', Courier, monospace;font-size:13px;line-height:1.2;tab-size:8;-moz-tab-size:8';

export function plainTextToPreHtml(text: string): string {
  return `<pre class="email-template-pre" style="${PRE_INLINE_STYLE}">${escapeHtmlPlain(normalizePlainText(text))}</pre>`;
}

export function plainTextToBrHtml(text: string): string {
  return escapeHtmlPlain(normalizePlainText(text)).replace(/\n/g, '<br>');
}
